import { render } from "./DropdownInput.vue?vue&type=template&id=48437375&scoped=true&ref=search"
import script from "./DropdownInput.vue?vue&type=script&lang=js"
export * from "./DropdownInput.vue?vue&type=script&lang=js"

import "./DropdownInput.vue?vue&type=style&index=0&id=48437375&scoped=true&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48437375"]])

export default __exports__